/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { LIST_ASSETS } from "../pages/ListedAssets/graphql/listed-assets.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {TEST_DATA } from "./config/assets-test-data"

const MODULE_NAME = "ListedAssetsService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ListedAssetsService {
    private static instance: ListedAssetsService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ListedAssetsService {
        if (!ListedAssetsService.instance) {
            ListedAssetsService.instance = new ListedAssetsService(props);
        }
        return ListedAssetsService.instance;
    }

    // async getListedAssets(size: number, offset: number) {
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     try {
    //         if (client) {
    //             const res = await client.query({
    //                 query: LIST_ASSETS,
    //                 variables: {
    //                     getAssetsSize: size,
    //                     getAssetsOffset: offset,
    //                     getAssetsCriteria: {
    //                         state: "listed"
    //                     }
    //                 },
    //             });
    //             log.success(MODULE_NAME, "getListedAssets: ", res);
    //             return res?.data?.getAssets;
    //         }
    //     } catch (err) {
    //         log.error(MODULE_NAME, "error in get assets", err);
    //         // throw Error(`${err?.message}`)
    //         return {
    //             pagination: {
    //                 nextOffset: 0,
    //                 totalItems: 0,
    //             },
    //             results: [],
    //         };
    //     }
    // }
    
    // async getAssets(size: number, offset: number) {
    //     let _found = TEST_DATA;
    //    _found = _found.slice(offset, offset + size);
    //    return {
    //        pagination: {
    //            nextOffset: offset + _found.length,
    //            totalItems: TEST_DATA?.length,  
    //        },
    //        results: _found,
    //    }
    // }
    async getAssets(size: number, offset: number) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: LIST_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state:"listed",
                            store:"61739cbd2fbe0a187c984fb6"
                          }
                    },
                    fetchPolicy:'network-only'
                });
                log.success(MODULE_NAME, "get assets result: ", res);
                // return res?.data?.getAssets;
                return {
            pagination: {
                nextOffset: offset + res?.data?.getAssets?.pageSize,
                totalItems: res?.data?.getAssets?.length,  
            },
            results: res?.data?.getAssets?.data,
        }
            }
        } catch (err) {
            log.error(MODULE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }
}
